var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"product-sort-filters",attrs:{"no-gutters":"","align":"center","justify":"end"}},[_c('v-select',{attrs:{"items":_vm.sortOptions,"value":_vm.sortFilter,"label":_vm.$t('products.orderBy'),"outlined":"","hide-details":""},on:{"change":_vm.handleSortFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }